import React, { useEffect } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { IconEdit, IconTrash } from 'components/Icons';
import { Box, Link, Stack, useDisclosure } from '@chakra-ui/react';
import { DeleteApproverModal } from '../DeleteApproverModal';
import { useNavigate } from 'react-router-dom';
import {
  ApproversListResult,
  useApproversListQuery,
  useDeleteApprover,
} from 'api/services/Admin';
import { Popover } from 'components/Popover/Popover';

const ActionsCell = ({ rowValues }: { rowValues: any }): JSX.Element => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    mutateAsync: deleteApprover,
    isLoading: isDeletingApprover,
    isSuccess,
  } = useDeleteApprover(rowValues.id);
  const { refetch: getApproversList } = useApproversListQuery();

  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess, onClose]);

  const handleDeleteApprover = async (): Promise<void> => {
    try {
      await deleteApprover(undefined);
      getApproversList();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Popover
        placement="bottom-start"
        useContextMenu
        bodyChildren={
          <Stack direction="column">
            <Stack direction="row">
              <Box as="div" mb={3}>
                <Link
                  display="flex"
                  onClick={(): void =>
                    navigate('/admin/samthykkjendur/action?mode=edit', {
                      state: { employeeData: rowValues },
                    })
                  }
                >
                  <IconEdit style={{ cursor: 'pointer', marginRight: 10 }} />
                  Breyta samþykkjenda
                </Link>
              </Box>
            </Stack>
            <Box as="div">
              <Link display="flex" onClick={onOpen}>
                <IconTrash
                  style={{ cursor: 'pointer', marginRight: 10 }}
                  width={20}
                />
                Eyða samþykkjenda
              </Link>
            </Box>
          </Stack>
        }
      />
      <DeleteApproverModal
        isOpen={isOpen}
        onClose={onClose}
        approverName={rowValues.name}
        isDeletingApprover={isDeletingApprover}
        onDeleteApprover={handleDeleteApprover}
      />
    </>
  );
};

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: 'name',
    header: () => <span>Samþykkjandi</span>,
    accessorFn: (row) => row,
    cell: ({ getValue }): JSX.Element => {
      const { name } = getValue() as ApproversListResult;
      return (
        <>
          <div>
            <span>{name}</span>
            {/* {approvesDepartments.length && (
              <span style={{ color: 'gray', fontSize: '90%' }}>
                {approvesDepartments[0].name} ({approvesDepartments[0].id})
              </span>
            )} */}
            {/* <span style={{ color: 'gray', fontSize: '90%' }}>
              {' '}
              - {employeeId.toUpperCase()}
            </span> */}
          </div>
        </>
      );
    },
  },
  {
    accessorKey: 'approves',
    header: () => <span>Samþykkir fyrir svið</span>,
    accessorFn: (row) => row,
    cell: ({ getValue }): JSX.Element => {
      const { approvesDepartments } = getValue() as ApproversListResult;
      return (
        <>
          <div>
            {approvesDepartments.length && (
              <span style={{ color: 'gray', fontSize: '90%' }}>
                {approvesDepartments[0].name} ({approvesDepartments[0].id})
              </span>
            )}
          </div>
        </>
      );
    },
  },
  {
    accessorKey: 'actions',
    header: () => (
      <Box display="flex" marginLeft="auto">
        Aðgerðir
      </Box>
    ),
    accessorFn: (row) => row,
    cell: ({ getValue }): JSX.Element | undefined => {
      const rowValues = getValue();
      return <ActionsCell rowValues={rowValues} />;
    },
  },
];
